import { Condition } from './Condition';

/**
 * The Filter class
 */
export class Filter {
  /**
   * The logical operator
   */
  public LogicalOperator: LogicalOperator;

  /**
   * The filters
   */
  public Filters: Filter[];

  /**
   * The Conditionss
   */
  public Conditions: Condition[];

  /**
   * Create a new Filter
   * @param fieldName The field name
   * @param comparison The comparison operator
   * @param value The value(s) (Can be a single value, or array of values)
   */
  constructor(logicalOperator: LogicalOperator = LogicalOperator.And, filters: Filter[] = [], conditions: Condition[] = []) {
    this.LogicalOperator = logicalOperator;
    this.Filters = filters;
    this.Conditions = conditions;
  }

  public ToDataQuery() {
    let clause: string;
    let clauses: string[] = [];

    for (let filter of this.Filters) {
      clause = filter.ToDataQuery();
      if (clause !== "") { clauses.push(clause); }
    }

    for (let condition of this.Conditions) {
      if (!condition.IsIgnored()) {
        clause = condition.ToDataQuery();
        if (clause !== "") { clauses.push(clause); }
      }
    }

    return clauses.length > 0 ? `(${clauses.join(this.LogicalOperator === LogicalOperator.And ? " and " : " or ")})` : "";
  }
}

export enum LogicalOperator {
  And = 0,
  Or = 1
}
